import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n';
import ModelSelect from './index';

const UnitLessonSelect = ({ ...props }) => (
  <ModelSelect
    {...props}
    ariaLabel="Select unit or lesson"
    optionsCacheKey={props.cacheKey}
    selectType="unit_lesson"
    title={`${props.disableUnitOptions ? I18n.t('lesson') : `${I18n.t('unit')}/${I18n.t('lesson')}`}:`}
  />
);

UnitLessonSelect.propTypes = {
  cacheKey: PropTypes.string,
  disableUnitOptions: PropTypes.bool,
  includeAllLessonsOption: PropTypes.bool,
  initialOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }).isRequired,
  parentResourceUrl: PropTypes.string,
  programId: PropTypes.number.isRequired,
  resourceUrl: PropTypes.string,
};

UnitLessonSelect.defaultProps = {
  cacheKey: null,
  disableUnitOptions: false,
  includeAllLessonsOption: false,
  parentResourceUrl: null,
  resourceUrl: null,
};

export default UnitLessonSelect;
